import { render, staticRenderFns } from "./index.layout.vue?vue&type=template&id=27d4abba&scoped=true&"
import script from "./index.layout.vue?vue&type=script&lang=js&"
export * from "./index.layout.vue?vue&type=script&lang=js&"
import style0 from "./index.layout.vue?vue&type=style&index=0&id=27d4abba&prod&scoped=true&lang=css&"
import style1 from "./index.layout.vue?vue&type=style&index=1&id=27d4abba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d4abba",
  null
  
)

export default component.exports